import { render, staticRenderFns } from "./AddConsultationRepair.vue?vue&type=template&id=28697161&scoped=true&"
import script from "./AddConsultationRepair.vue?vue&type=script&lang=js&"
export * from "./AddConsultationRepair.vue?vue&type=script&lang=js&"
import style0 from "./AddConsultationRepair.vue?vue&type=style&index=0&id=28697161&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28697161",
  null
  
)

export default component.exports